
import writeXlsxFile from 'write-excel-file'
import {formatDate} from "../../misc/timeTools.js";
import Papa from "papaparse"

export default class ExportOdoo {

    constructor(logger) {
        this._logger = logger;
    }

    generateOdooExportMembers(communityCompany) {
        if(!this._logger)
            throw new Error("_logger unset");

        const data = this.getDataMembers(communityCompany);
        const schema = this.getSchemaMembers();

        // this._logger.debug("generateOdooExportMembers schema",schema)
        // this._logger.debug("generateOdooExportMembers data",data)

        if(!data)
            return;

        const xlsData = writeXlsxFile(data,{
            schema,
            fileName: communityCompany.ecn+'_Odoo_Members_'+ formatDate(new Date()) +'_v3.xlsx'
        })

        return xlsData;

    }

    getDataMembers(communityCompany) {

        const data = [];

        for(const member of communityCompany.members) {
            data.push({
                member: member,
                communityCompany: communityCompany,
                tags: "Digital2OdooMemberV3",
            })
        }


        return data;
    }

    getSchemaMembers() {
        return [
            {
                column: 'name',
                type: String,
                value: dataObject => dataObject.member.billingData.addressPostal?.name || "",
            },
            { // this should be "External ID"
                column: 'ref',
                type: String,
                value: dataObject => dataObject.member.clientCode,
            },
            {
                column: 'id',
                type: String,
                value: dataObject => dataObject.member.clientCode,
            },
            {
                column: 'is_company',
                type: String,
                value: dataObject =>"1", // @todo should we change this for private members? migration problems in odoo?
            },
            {
                column: 'company_name',
                type: String,
                value: dataObject => dataObject.member.billingData.addressPostal?.name || "",
            },
            {
                column: 'country_id',
                type: String,
                value: dataObject =>"AT",
            },
            {
                column: 'state_id',
                type: String,
                value: dataObject =>"",
            },

            {
                column: 'zip',
                type: String,
                value: dataObject => dataObject.member.billingData.addressPostal?.zip || "",
            },
            {
                column: 'city',
                type: String,
                value: dataObject => dataObject.member.billingData.addressPostal?.city || "",
            },
            {
                column: 'street',
                type: String,
                value: dataObject => dataObject.member.billingData.addressPostal?.address || "",
            },
            {
                column: 'street2',
                type: String,
                value: dataObject => dataObject.member.billingData.addressPostal?.addressExtra || "",
            },


            {
                column: 'phone',
                type: String,
                value: dataObject => dataObject.member.contactData?.phoneNumber || "",
            },
            {
                column: 'mobile',
                type: String,
                value: dataObject => "",
            },
            {
                column: 'email',
                type: String,
                value: dataObject => dataObject.member.contactData?.emailAddress || "",
            },

            {
                column: 'vat',
                type: String,
                value: dataObject => dataObject.member.billingData?.taxInfo?.uid || "",
            },
            {
              column: 'bank_ids/id',
              type: String,
              value: dataObject => dataObject.member.clientCode || "",
            },
            {
                column: 'bank_ids/bank',
                type: String,
                value: dataObject => dataObject.member.billingData?.wireInfo?.bic || "",
            },
            {
                column: 'bank_ids/acc_number',
                type: String,
                value: dataObject => dataObject.member.billingData?.wireInfo?.iban || "",
            },

            {
                column: 'Tags',
                type: String,
                value: dataObject => dataObject.tags,
            },
            {
                column: 'company_id',
                type: String,
                value: dataObject => dataObject.communityCompany?.name || "",
            },
        ];
    }

    generateOdooExportFiBuV1AsCsv(fiBuCollectionV1, includeAttachments) {
        if(!this._logger)
            throw new Error("_logger unset");

        const data = this.getDataFiBuCsvV1(fiBuCollectionV1, includeAttachments);

        /// @todo check for replace due to problems during import with amounts > 1.000
        const csvString = Papa.unparse({
            "data": data,
        }, {
            quotes: false, //or array of booleans
            quoteChar: '"',
            escapeChar: '"',
            delimiter: ";",
            header: true,
            newline: "\r\n",
            skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
            columns: null //or array of strings
        });

        return csvString;

    }

    getDataFiBuCsvV1(fiBuCollectionV1, includeAttachments) {

        const data = [];

        for(const entry of fiBuCollectionV1) {

            let isFirst = true;
            for(const lineFibu of entry.fibuLines) {
                const line = {}
                if(isFirst) {
                    line["name"] = entry.invoiceNumber;
                    line["ref"] = entry.invoiceNumber;
                    line["partner_id"] = entry.clientCode;
                    line["invoice_date"] = formatDate(entry.invoiceDate);
                    line["invoice_date_due"] = formatDate(entry.dueDate);
                    line["currency_id"] = "EUR" // for safety
                    line["quick_edit_total_amount"] = entry.totalGross // brutto betrag gesamt
                    line["is_storno"] = entry.isStorno;
                    line["payment_reference"] = entry.invoiceNumber;
                    line["journal_id"] = entry.journal; // for safety
                    line["company_id"] = entry.company;  // for safety
                }

                line["invoice_line_ids/product_id"] = lineFibu.itemReference;
                line["invoice_line_ids/price_unit"] = lineFibu.amountSingle;
                line["invoice_line_ids/quantity"]  = lineFibu.count;
                // line["invoice_line_ids/price_total"] = lineFibu.amountTotal;
                line["invoice_line_ids/deferred_start_date"] = formatDate(lineFibu.dateStart);
                line["invoice_line_ids/deferred_end_date"] = formatDate(lineFibu.dateEnd);

                // pdf at last (if any)
                if(isFirst) {
                    if(includeAttachments
                        && entry.pdfDataBase64?.length
                        && entry.pdfDataBase64?.length) {

                        // attachment_ids/datas is only for output
                        line["invoice_pdf_report_file"] = entry.pdfDataBase64;
                        line["attachment_ids/name"] = entry.pdfName;
                        line["attachment_ids/type"] = "File";
                    }
                    isFirst=false;
                }

                data.push(line)
            }
        }

        return data;
    }


}
